/**
 * Rate of Change (ROC)
 *
 * Momentum oscillator measuring the percentage change between the current
 * close and the close `period` bars ago.
 * Formula: ROC = ((Close - Closeₙ) / Closeₙ) × 100.
 * Default period: 12.
 *
 * Category: Momentum | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { getSource } from "./sma";

export const rocIndicator: IndicatorDefinition = {
  id: "roc",
  name: "Rate of Change",
  shortName: "ROC",
  category: "momentum",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 12, min: 1, max: 200 },
    { key: "source", label: "Source", type: "select", default: "close", options: [
      { label: "Close", value: "close" }, { label: "Open", value: "open" },
      { label: "High", value: "high" }, { label: "Low", value: "low" },
    ]},
    { key: "color", label: "Color", type: "color", default: "#7E57C2" },
  ],
  plots: [
    { key: "roc", label: "ROC", color: "#7E57C2", style: "line", lineWidth: 2, priceScaleId: "roc" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period, source = "close" } = params;
    const src = getSource(candles, source);
    const data: { time: number; value: number }[] = [];

    for (let i = period; i < src.length; i++) {
      const prev = src[i - period];
      const roc = prev !== 0 ? ((src[i] - prev) / prev) * 100 : 0;
      data.push({ time: candles[i].time, value: roc });
    }

    return [{ key: "roc", data }];
  },
};
